/** App caricata in iframe Techyweb (?tl4k-embedded=1). */
export function isTl4kEmbedded(
  search: string = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  const params = new URLSearchParams(search);
  return params.get('tl4k-embedded') === '1';
}

export function embeddedInParent(): boolean {
  return typeof window !== 'undefined' && window.parent !== window;
}

/**
 * Una volta vista `tl4k-embedded=1` in iframe, l'app resta embedded per tutta
 * la vita della pagina: `navigate()` / `pushState` / `replaceState` interni che
 * perdono la query non devono far ricomparire header e footer dell'app dentro
 * TechyWeb (puzzle-app, magic-page, wordcloud, disegna: 2026-10-13).
 */
let embeddedInShellLatched = false;

/** Solo test: azzera lo stato ricordato. */
export function resetTl4kEmbeddedInShellLatch(): void {
  embeddedInShellLatched = false;
}

/** Embedded in shell Techyweb: nascondere TL4KAppHeader (auth nel parent). */
export function isTl4kEmbeddedInShell(
  search: string = typeof window !== 'undefined' ? window.location.search : '',
): boolean {
  if (!embeddedInParent()) return false;
  if (isTl4kEmbedded(search)) embeddedInShellLatched = true;
  return embeddedInShellLatched;
}
